import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const features = [
  {
    icon: FiIcons.FiFilm,
    title: "Concept-First Animations",
    desc: "Every chapter starts with a cinematic explanation. See forces, atoms, and code come alive on screen."
  },
  {
    icon: FiIcons.FiLayers,
    title: "Connected Portal",
    desc: "One login, one journey. Students find all their courses, progress, and practice in a single place."
  },
  {
    icon: FiIcons.FiCpu,
    title: "AI-Native Learning",
    desc: "We weave AI thinking into how students explore data, patterns, and problem-solving from day one."
  }
];

const WhySection = () => {
  return (
    <section className="py-24 bg-slate-900 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 to-slate-900 pointer-events-none" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-100 mb-6">Why LearnAnimated?</h2>
          <p className="text-slate-400 text-lg">
            Textbooks tell you what to memorize. We show you what it actually means. LearnAnimated turns science, math, and AI into visual stories.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <div key={idx} className="p-8 rounded-2xl bg-slate-800/50 border border-slate-700 hover:border-cyan-500/50 transition-colors group">
              <div className="w-12 h-12 bg-cyan-900/30 rounded-lg flex items-center justify-center mb-6 text-cyan-400 group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-slate-100 mb-3">{feature.title}</h3>
              <p className="text-slate-400 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;